import React, { useContext } from 'react'
import { Form } from 'antd'
import { RichTextEditor } from 'packages/components/RichText'
import { EditProductQuestionItemProps } from '../../types'
import { editSubQuestion } from '../../utils'
import { debounce } from '@seiue/util'
import { EditPaperContext } from '@/features/test-paper/pages/EditPaper/context'

export const EditSubStem: React.FC<EditProductQuestionItemProps> = ({
  curQuestion,
  subQuestions,
  setSubQuestions,
  treeNodeId,
}) => {
  const { limitLevel } = useContext(EditPaperContext)
  return (
    <Form.Item label={'题干'}>
      <RichTextEditor
        readOnly={limitLevel > 2}
        minHeight={64}
        value={curQuestion.stem || undefined}
        onChange={debounce((v) => {
          const newSubQuestions = editSubQuestion(
            subQuestions,
            treeNodeId || 0,
            { stem: v }
          )
          setSubQuestions(newSubQuestions)
        }, 500)}
        excludeKeys={[
          'headerSelect',
          'group-upload',
          'insertLink',
          'fullScreen',
        ]}
        insertKeys={{
          index: 17,
          keys: ['uploadImage', 'insertFormula'],
        }}
      />
    </Form.Item>
  )
}
